module.exports = __webpack_public_path__ + "img/aaab1e1.png";